import { combineEpics } from 'redux-observable';

import { promotionEpic } from './promotion.epic';
import { sessionLocalStorageEpic } from './session-local-storage.epic';
import { sessionEpic } from './session.epic';

export const accountEpic = combineEpics(sessionLocalStorageEpic, sessionEpic, promotionEpic);
